const EVENT_FIELD_VALIDATION_FAILED = 'field-validation-failed';
const EVENT_FIELD_VALIDATION_PASSED = 'field-validation-passed';
const EVENT_SPINBOX_CHANGED = 'spinbox-changed';

export default {
    EVENT_FIELD_VALIDATION_FAILED,
    EVENT_FIELD_VALIDATION_PASSED,
    EVENT_SPINBOX_CHANGED
};



// WEBPACK FOOTER //
// ./app/general/js/constants.js